// A booking can cover several days (haldi, mehndi, wedding...). New bookings carry `eventDates`; older ones only `eventDate`.
export const MAX_BOOKING_DATES = 10;

export const bookingDateList = (booking) => {
    const list = booking?.eventDates?.length ? booking.eventDates : [booking?.eventDate];
    return list.filter(Boolean).map(d => new Date(d)).sort((a, b) => a - b);
};

const day = (d, opts) => d.toLocaleDateString('en-IN', opts);

// "Thursday, 22 October 2026" for one date; "22, 23 & 24 Oct 2026" style for several
export const formatBookingDates = (booking, long = true) => {
    const list = bookingDateList(booking);
    if (list.length <= 1) return list[0] ? day(list[0], long ? { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' } : { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
    return list.map(d => day(d, { day: 'numeric', month: 'short' })).join(', ') + ' ' + list[list.length - 1].getFullYear() + ' (' + list.length + ' days)';
};
